import {msg, str} from '@lit/localize';
import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {openDialog} from '../../slices/statusSlice';
import {cancelSubscription} from '../../slices/planSlice';
import store from '../../store';

@customElement('arc-cancel-subscription-button')
export class CancelSubscriptionButton extends connect(store)(LitElement) {

	static properties = {
		loading: {type: String},
	};

	constructor() {
		super();
		this.loading = '';
	}

	stateChanged(state) {
		this.loading = state.plan.loading;
	}

	async onCancelSubscription() {
		const dialogOptions = {
			title: msg('cancel_sub_confirm_title'),
			message: msg(str`cancel_sub_confirm_message`),
			labelConfirm: msg('cancel_sub_confirm_ok'),
			labelCancel: msg('cancel_sub_confirm_cancel'),
		};
		const handleConfirm = async () => {
			await store.dispatch(cancelSubscription());
			window.removeEventListener('confirm', handleConfirm);
		};
		window.addEventListener('confirm', handleConfirm);
		store.dispatch(openDialog(dialogOptions));
	}

	render() {
		return html`
			<arc-button
				@click=${() => this.onCancelSubscription()}
				title="${msg('cancel_sub_button_label')}"
				type="secondary"
				?disabled="${this.loading === 'cancelSubscription'}"
			></arc-button>
		`;
	}
}
